import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { trackGAEvent } from '../utilities/tracking'
import { ThreeBounceSpinner } from '../Global/LoadingSpinner'
import {
    LoadingWrapper,
    LoadingTextWrapper
} from '../StyledComponents/Classifier/LoadingScreen'
import { QuestionBackLink } from '../StyledComponents/IntroQuestions/Question'
import InfoModal from '../Global/InfoModal'
import { FillerDiv } from '../StyledComponents/Fillers'
import { classifyPlant, resetClassifyImage, getUserProfile } from '../../actions'
import { CLASSIFIER, PLANT } from '../../constants/routes'

class PlantClassification extends Component {
    constructor(props) {
        super(props)

        this.state = {
            notReliable: false,
        }

        this.backClicked = this.backClicked.bind(this)
    }

    componentDidMount() {
        const {
            image, model, history, recognizedPlant, classify, sessionState, getProfile,
        } = this.props

        if (!!sessionState && !!sessionState.idToken && !sessionState.gardenKnowledge) {
            const { token } = sessionState.idToken
            getProfile(sessionState.authUser.uid, token)
        }

        if (recognizedPlant) {
            history.push(PLANT.replace(':id', recognizedPlant))
            return
        }

        if (model && image) {
            setTimeout(() => { classify(model, image, sessionState.gardenKnowledge) }, 10)
        }

        if (!model) {
            history.push(CLASSIFIER)
        }
    }

    componentWillReceiveProps(newProps) {
        const { sessionState, recognizedPlant, reliability } = newProps

        if (recognizedPlant) {
            if (reliability && reliability < 0.7) {
                this.setState({ notReliable: true })
                trackGAEvent('interaction', {
                    interaction_value: 'undefined',
                    interaction_category: 'Plant-Classifier',
                    interaction_action: 'plant-classify-not-reliable',
                    interaction_label: sessionState.gardenKnowledge,
                })
                return
            }
            trackGAEvent('interaction', {
                interaction_value: 'undefined',
                interaction_category: 'Plant-Classifier',
                interaction_action: 'plant-classify-success',
                interaction_label: sessionState.gardenKnowledge,
            })
            this.props.history.push(PLANT.replace(':id', newProps.recognizedPlant))
        }
    }

    componentDidUpdate(prevProps) {
        const {
            model, image, classify, sessionState, getProfile,
        } = this.props

        if (!prevProps.model && model && image) {
            classify(model, image, sessionState.gardenKnowledge)
        }

        if (!prevProps.sessionState.idToken && !!sessionState.idToken
            && !sessionState.gardenKnowledge) {
            const { token } = sessionState.idToken
            getProfile(sessionState.authUser.uid, token)
        }
    }

    backClicked() {
        this.props.history.goBack()
    }

    render() {
        const { image, history, resetClassification } = this.props

        let infoModal = ''
        if (!image) {
            infoModal = (
                <InfoModal
                    text="Mache ein Foto deiner Pflanze, um sie zu klassifizieren."
                    headerText="Kein Bild ausgewählt"
                    isOpen
                    closeModal={() => history.push(CLASSIFIER)}
                />
            )
        } else if (this.state.notReliable) {
            infoModal = (
                <InfoModal
                    text="Für dieses Foto konnte keine vernünftige Klassifizierung vorgenommen werden. Versuche es mit einem anderen Bild"
                    headerText="Keine Pflanze erkannt"
                    isOpen
                    closeModal={() => {
                        resetClassification()
                        history.push(CLASSIFIER)
                    }}
                />
            )
        }

        const backLink = (
            <QuestionBackLink onClick={this.backClicked} >
                <FontAwesome
                    name="close"
                    size="lg"
                />
            </QuestionBackLink>
        )

        return (
            <FillerDiv>
                {infoModal}
                {backLink}
                <LoadingTextWrapper>Das Bild wird analysiert...</LoadingTextWrapper>
                <LoadingWrapper><ThreeBounceSpinner /></LoadingWrapper>
            </FillerDiv>
        )
    }
}

const mapStateToProps = state => ({
    recognizedPlant: state.classifier.recognizedPlant,
    reliability: state.classifier.reliability,
    image: state.classifier.image,
    model: state.tensorflowModel.model,
    sessionState: state.sessionState,
})

export default compose(
    withRouter,
    connect(mapStateToProps, {
        classify: classifyPlant,
        resetClassification: resetClassifyImage,
        getProfile: getUserProfile,
    })
)(PlantClassification)



// WEBPACK FOOTER //
// ./src/components/pages/PlantClassification.js